import { createResource } from 'redux-rest-resource'
import { baseURL } from './'

export const { types, actions, rootReducer } = createResource({
  name: 'extraction',
  pluralName: 'extractions',
  url: `${baseURL}/extract`,
  credentials: 'include',
  actions: {
    exportPermits: {
      method: 'GET',
      gerundName: 'exporting',
      url: './permits',
      reduce: (state, { status }) => ({
        ...state,
        isExportingPermits: status === 'pending'
      })
    },
    exportPdps: {
      method: 'GET',
      gerundName: 'exporting',
      url: './pdps',
      reduce: (state, { status }) => ({
        ...state,
        isExportingPdps: status === 'pending'
      })
    },
    exportCompanies: {
      method: 'GET',
      gerundName: 'exporting',
      url: './companies',
      reduce: (state, { status }) => ({
        ...state,
        isExportingCompanies: status === 'pending'
      })
    }
  }
})
